import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { BulletText } from 'partial/OfferDetails/components/BulletCollapse/BulletCollapse';
import { WideOfferApplyButton } from '../fragments/OfferApplyButtons/WideOfferApplyButton';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer/index';
import './StandardHomeLoanOffer.scss';

const HomeLoanOfferBullets = ({ datatestid, bulletList }) => {
  return (
    <div className="bulletContainer lism-padL0">
      <ul className="padL20">
        {bulletList.length > 0
          ? bulletList.map((item, index) => {
              return (
                <BulletText
                  key={`${datatestid}-itemKey-${index}`}
                  datatestid={datatestid ? `${datatestid}` : null}
                  text={item}
                  index={index}
                  sizeClass={'mediumText'}
                />
              );
            })
          : null}
      </ul>
    </div>
  );
};

const HomeLoanOfferNameAndInfo = ({
  datatestid,
  offerDetails,
  seenPixel,
  clickApplyLoanNameHandler,
}) => {
  const hasBullets = offerDetails.bullets.length > 0;
  return (
    <FlexContainer className="flex-column padR24 mobilePadR0">
      <FlexContainer>
        <Label
          datatestid={`${datatestid}-lender-name`}
          type="Subtitle-1"
          className="bold"
          onClick={clickApplyLoanNameHandler}
        >
          {offerDetails.lender.name}
          {seenPixel}
        </Label>
        <div className="padB16" />
      </FlexContainer>
      {hasBullets && (
        <HomeLoanOfferBullets
          datatestid={datatestid}
          bulletList={offerDetails.bullets}
        />
      )}
    </FlexContainer>
  );
};

const StandardHomeLoanOffer = ({
  datatestid,
  offerMetadata,
  clickApplyHandler,
  clickApplyLoanNameHandler,
  clickApplyImageHandler,
  seenPixel,
}) => {
  const offerDetails = offerMetadata.bestProduct;
  return (
    <SectionContainer className="StandardHomeLoanOffer grayShadow offerCard">
      <Row className="offerCardRow">
        <FlexContainer className="align-items-center flex-mobile-col">
          <img
            data-testid={`${datatestid}-hl-offer-image`}
            className="homeLoanOfferImage padR24 mobilePadR0 m-padB16"
            src={offerDetails.lender.logoUrl}
            alt="Home Loan Offer"
            onClick={clickApplyImageHandler}
          ></img>
          <FlexContainer className="justify-between format100 flex-mobile-col">
            <HomeLoanOfferNameAndInfo
              datatestid={`${datatestid}-hl-offer`}
              offerDetails={offerDetails}
              seenPixel={seenPixel}
              clickApplyLoanNameHandler={clickApplyLoanNameHandler}
            />
            <WideOfferApplyButton
              datatestid={`${datatestid}-offer`}
              partnerName={offerDetails.lender.name}
              clickApplyHandler={clickApplyHandler}
            />
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export { StandardHomeLoanOffer };
